import React from "react";
import styled from "styled-components";
import { IFooter } from "../../content/interfaces";
import { useContent } from "../prefetch";
import { EmbeddedContent } from "../EmbeddedContent";
import { LegacyFooter } from "./LegacyFooter";

const LegacyFooterWrapper = styled.div`
  flex-shrink: 0;
`;

type Props = IFooter & {
  footerHTML: {
    url: "legacy" | string;
    useShadowDom: boolean;
  };
};

export const Footer = ({ ...rest }: Props) => {
  const content = useContent("tal_footer");
  if (!content)
    return (
      <LegacyFooterWrapper>
        <LegacyFooter {...rest} />;
      </LegacyFooterWrapper>
    );

  return <EmbeddedContent content={content} useShadowDom={false} />;
};
